import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "year-groups",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "year-groups" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
